import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Table, Input, Modal } from "antd";

import { getSSPAcademicYear } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE, SORT_FIELD_NAME, SORT_UP_DOWN } from "../../utils/contrains";
import {
  req_list_ssp_school_source_college,
  req_downloadfile_school_source_college,
} from "../../api";
import StudentSourceDetailView from "./student-source-details-view";
import SourceSchoolInfoModal from "./source-school-info-modal";
import StudentsNowInfoModal from "./students-now-info-modal";
import StudentSourceItemModal from "./student-source-item-modal";
class CollegePlanViewList extends Component {
  state = {
    loading: false,
    planAcademicYear: getSSPAcademicYear(new Date()),
    countyCityName: "NONE",
    userLevel: "NORMAL",
    item: {},
    cluster: "",
    // 分頁參數
    items: [],
    rows: [],
    colleges: [
      // { label: "管理學院", value: "59" },
      { label: "民生暨管理學院", value: "60" },
      { label: "設計學院", value: "62" },
      { label: "藝術學院", value: "63" },
      // { label: "旅遊學院", value: "193" },
    ],
    domnloadFile: "",
    selectedCollege: "NONE",
    isSourceSchoolModal: false,
    isStudentsNowModal: false,
    isStudentSourceItemModal: false,
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    //this.api_list_items();
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { planAcademicYear, selectedCollege, columnSort, orderBy } =
      this.state;
    const { token, role, userCode } = this.props.user;
    //console.log("api_list_items：", columnSort, orderBy);
    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_list_ssp_school_source_college(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCollege,
      columnSort,
      orderBy,
      token
    );
    this.setState({ loading: false });
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
      //console.log(items);
    } else {
      const items = [];
      this.setState({ items });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, planAcademicYear, selectedCollege } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_school_source_college(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCollege,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////
  handleCollegeChange = (event) => {
    this.setState({
      selectedCollege: event.target.value,
    });
    //console.log(value);
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      console.log(status);
      const { field, order } = sorter;

      //"ascend" 多, descend "少"
      console.log(field, order);
      this.setState(
        { filterStatus: status, columnSort: field, orderBy: order },
        () => {
          this.api_list_items(pagination.current);
        }
      );
    } else {
      this.setState(
        { filterStatus: "", columnSort: "NA", orderBy: SORT_UP_DOWN },
        () => {
          this.api_list_items(pagination.current);
        }
      );
    }
  };

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "SourceSchoolInfo":
        this.setState({ isSourceSchoolModal: true, item });
        break;
      case "SchoolStudentNow":
        //console.log(item);
        this.setState({ isStudentsNowModal: true, item });
        break;
      case "NumberOfPeopleTotalAA":
        this.setState({ isStudentSourceItemModal: true, cluster: "AA", item });
        break;
      case "NumberOfPeopleTotalAB":
        this.setState({ isStudentSourceItemModal: true, cluster: "AB", item });
        break;
      case "NumberOfPeopleTotalAC":
        this.setState({ isStudentSourceItemModal: true, cluster: "AC", item });
        break;
      case "NumberOfPeopleTotalAD":
        this.setState({ isStudentSourceItemModal: true, cluster: "AD", item });
        break;
      case "NumberOfPeopleTotalAE":
        this.setState({ isStudentSourceItemModal: true, cluster: "AE", item });
        break;
      case "NumberOfPeopleTotalF":
        this.setState({ isStudentSourceItemModal: true, cluster: "AF", item });
        break;
      case "NumberOfPeopleTotalAG":
        this.setState({ isStudentSourceItemModal: true, cluster: "AG", item });
        break;
      case "NumberOfPeopleTotalAH":
        this.setState({ isStudentSourceItemModal: true, cluster: "AH", item });
        break;
      case "NumberOfPeopleTotalAI":
        this.setState({ isStudentSourceItemModal: true, cluster: "AI", item });
        break;
      case "NumberOfPeopleTotalAJ":
        this.setState({ isStudentSourceItemModal: true, cluster: "AJ", item });
        break;
      case "NumberOfPeopleTotalAK":
        this.setState({ isStudentSourceItemModal: true, cluster: "AK", item });
        break;
      case "NumberOfPeopleTotalAM":
        this.setState({ isStudentSourceItemModal: true, cluster: "AM", item });
        break;
      case "NumberOfPeopleTotalAN":
        this.setState({ isStudentSourceItemModal: true, cluster: "AN", item });
        break;
      case "NumberOfPeopleTotalAO":
        this.setState({ isStudentSourceItemModal: true, cluster: "AO", item });
        break;
      case "NumberOfPeopleTotalAP":
        this.setState({ isStudentSourceItemModal: true, cluster: "AP", item });
        break;
      case "NumberOfPeopleTotalAQ":
        this.setState({ isStudentSourceItemModal: true, cluster: "AQ", item });
        break;
      case "NumberOfPeopleTotalAR":
        this.setState({ isStudentSourceItemModal: true, cluster: "AR", item });
        break;
      case "NumberOfPeopleTotalAX":
        this.setState({ isStudentSourceItemModal: true, cluster: "AX", item });
        break;
      case "NumberOfPeopleTotalAY":
        this.setState({ isStudentSourceItemModal: true, cluster: "AY", item });
        break;
      case "NumberOfPeopleTotalAZ":
        this.setState({ isStudentSourceItemModal: true, cluster: "AZ", item });
        break;
      case "NumberOfPeopleTotalBA":
        this.setState({ isStudentSourceItemModal: true, cluster: "BA", item });
        break;
      case "NumberOfPeopleTotalBB":
        this.setState({ isStudentSourceItemModal: true, cluster: "BB", item });
        break;
      case "NumberOfPeopleTotalBC":
        this.setState({ isStudentSourceItemModal: true, cluster: "BC", item });
        break;
      case "NumberOfPeopleTotalBD":
        this.setState({ isStudentSourceItemModal: true, cluster: "BD", item });
        break;
      case "NumberOfPeopleTotalBE":
        this.setState({ isStudentSourceItemModal: true, cluster: "BE", item });
        break;
      case "NumberOfPeopleTotalCA":
        this.setState({ isStudentSourceItemModal: true, cluster: "CA", item });
        break;
      case "NumberOfPeopleTotalDA":
        this.setState({ isStudentSourceItemModal: true, cluster: "DA", item });
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  handle_expanded = (expandedRows) => {
    //console.log(expandedRows);
    if (!expandedRows) {
      this.handle_data_refresh();
    }
  };

  refreshdata = () => {
    //console.log("refreshdata");
    this.api_page_item_noLoad(this.current);
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    const { planAcademicYear } = this.state;
    this.columns = [
      {
        title: "地區",
        dataIndex: "CountyCityName",
        width: 45,
        align: "center",
        fixed: "left",
        render: (field) => {
          return (
            <>
              <span style={{ fontWeight: 900 }}> {field}</span>
            </>
          );
        },
      },
      {
        title: "生源學校",
        width: 120,
        fixed: "left",
        render: (item) => {
          const { HighSchoolTwName } = item;
          return (
            <>
              <button
                className="btn btn-outline-dark btn-sm"
                style={{ width: "100%", fontWeight: 900 }}
                onClick={() =>
                  this.handle_show_ui_modal("SourceSchoolInfo", item)
                }
              >
                {HighSchoolTwName}
              </button>
            </>
          );
        },
      },
      {
        title: () => {
          return <>{planAcademicYear - 1 + "年註冊"}</>;
        },
        dataIndex: "EnrolledStudentTotal",
        width: 45,
        responsive: ["lg"],
        align: "right",
        fixed: "left",
        sorter: "EnrolledStudentTotal",
        render: (text, record) => {
          return (
            <div>
              {" "}
              <button
                className={
                  parseInt(text) > 0
                    ? "btn btn-outline-success btn-sm"
                    : "btn btn-light btn-sm"
                }
                disabled={parseInt(text) > 0 ? false : true}
                style={{ width: "100%", fontWeight: 900 }}
                onClick={() =>
                  this.handle_show_ui_modal("SchoolStudentNow", record)
                }
              >
                {text}
              </button>
            </div>
          );
        },
      },
      {
        title: "規劃總額",
        dataIndex: "PlanStudentTotal",
        width: 45,
        align: "center",
        fixed: "left",
        sorter: "PlanStudentTotal",
        render(text, record) {
          return {
            props: {
              style: {
                background: parseInt(text) > 0 ? "#FFD700" : "#FFFFFF",
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "商管群",
        dataIndex: "NumberOfPeopleTotalAA",
        width: 40,
        align: "right",
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAA", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "餐旅群",
        dataIndex: "NumberOfPeopleTotalAB",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAB", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "設計群",
        dataIndex: "NumberOfPeopleTotalAC",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAC", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "藝術群",
        dataIndex: "NumberOfPeopleTotalAD",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAD", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "機械群",
        dataIndex: "NumberOfPeopleTotalAE",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAE", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "食品群",
        dataIndex: "NumberOfPeopleTotalAF",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAF", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "土木群",
        dataIndex: "NumberOfPeopleTotalAG",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAG", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "外語群英語類",
        dataIndex: "NumberOfPeopleTotalAH",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAH", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "電子與電機群資電類",
        dataIndex: "NumberOfPeopleTotalAI",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAI", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "家政群生活應用類",
        dataIndex: "NumberOfPeopleTotalAJ",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAJ", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "家政群幼保類",
        dataIndex: "NumberOfPeopleTotalAK",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAK", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "農業類",
        dataIndex: "NumberOfPeopleTotalAM",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAM", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            藝術<br></br>單招
          </>
        ),
        dataIndex: "NumberOfPeopleTotalBA",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalBA", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            特殊<br></br>選才
          </>
        ),
        dataIndex: "NumberOfPeopleTotalBB",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalBB", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            繁星<br></br>入學
          </>
        ),
        dataIndex: "NumberOfPeopleTotalBC",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalBC", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            運優<br></br>單招
          </>
        ),
        dataIndex: "NumberOfPeopleTotalBD",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalBD", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            一般<br></br>獨招
          </>
        ),
        dataIndex: "NumberOfPeopleTotalBE",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalBE", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            四技<br></br>申請<br></br>高中生
          </>
        ),
        dataIndex: "NumberOfPeopleTotalCA",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalCA", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: (
          <>
            技優<br></br>甄審
          </>
        ),
        dataIndex: "NumberOfPeopleTotalDA",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalDA", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      items,
      item,
      cluster,
      planAcademicYear,
      selectedCollege,
      colleges,
      isSourceSchoolModal,
      isStudentsNowModal,
      isStudentSourceItemModal,
    } = this.state;

    const title = (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <select
          className="form-control"
          style={{
            width: "160px",
            display: "inline-block",
            backgroundColor: "LightCyan",
          }}
          onChange={this.handleCollegeChange}
          value={selectedCollege}
        >
          <option key={"NONE"} value={"NONE"}>
            請選擇學院
          </option>
          {colleges.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "6px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </button>
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "6px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px", marginBottom: "6px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </button>
      </>
    );

    const expandedRowRender = (row) => {
      const { HighSchoolCode, NowYearMonth } = row;
      const { planAcademicYear, selectedCollege } = this.state;
      return (
        <StudentSourceDetailView
          schoolcode={HighSchoolCode}
          planAcademicYear={planAcademicYear}
          yearMonth={NowYearMonth}
          collegeCode={selectedCollege}
          refreshdata={this.refreshdata}
        ></StudentSourceDetailView>
      );
    };
    return (
      <>
        <Card title={title}>
          <Table
            bordered
            scroll={{ x: 800 }}
            loading={loading}
            rowKey="Id"
            dataSource={items}
            onChange={this.handle_table_change}
            expandable={{
              columnWidth: "10px",
              expandedRowRender,
              onExpandedRowsChange: this.handle_expanded,
            }}
            pagination={false}
            columns={this.columns}
          />
          <Modal
            destroyOnClose={true}
            visible={isSourceSchoolModal}
            width={"85%"}
            onOk={() => {
              this.setState({ isSourceSchoolModal: false });
              // this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isSourceSchoolModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SourceSchoolInfoModal item={item} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isStudentsNowModal}
            width={"85%"}
            onOk={() => {
              this.setState({ isStudentsNowModal: false });
              // this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isStudentsNowModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <StudentsNowInfoModal item={item} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isStudentSourceItemModal}
            width={"85%"}
            onOk={() => {
              this.setState({ isStudentSourceItemModal: false });
              // this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isStudentSourceItemModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <StudentSourceItemModal
              item={item}
              cluster={cluster}
              collegeCode={selectedCollege}
            />
          </Modal>
        </Card>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CollegePlanViewList);
